/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
// import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
// import { getCartState } from '@msdyn365-commerce/global-state';
import { countryCodeList } from './countryList';

import { ICountryPickerViewProps } from './lds-country-picker';
import { CountryOption } from '../../interfaces/country-option.interface';
import { LanguageOption } from '../../interfaces/language-option.interface';
// @ts-ignore
import { Primary } from '@churchofjesuschrist/eden-buttons';
import { setLocale } from '../../helpers/localization/locale.helper';
import { ILocale } from '../../interfaces/ILocale';

/**
 * Functional component which renders country picker module.
 * @param props - Configuration for the country picker component.
 * @returns React.FC<ICountryPickerViewProps> - Functional component of the country picker module.
 */
export const countryPickerView: React.FC<ICountryPickerViewProps> = (props: ICountryPickerViewProps) => {
    const [country, setCountry] = React.useState<CountryOption | null>();
    const [language, setLanguage] = React.useState<LanguageOption | null>();
    const [cartState, setCartState] = React.useState();
    const [selectedCountry, setSelectedCountry] = React.useState('USA');
    const [selectedLanguage, setSelectedLanguage] = React.useState('EN');

    const getCurrentCountry = async () => {
        const countryCodes: any = countryCodeList.filter((country: any) => {
            return country.twoLetterCode === props.context.request.marketSettings?.countryRegion;
        });
        let country;
        // @ts-ignore
        if (props.data.countries.result && countryCodes && countryCodes[0]) {
            //@ts-ignore
            country = props.data.countries.result.filter(country => {
                // if (userCountry && userCountry[0]) {
                //@ts-ignore
                // return country.countryRegionId === userCountry[0].Value.StringValue;
                return country.countryRegionId === countryCodes[0].threeLetterCode;
                // } else {
                //     return;
                // }
            });
        }

        if (country) {
            setSelectedCountry(country[0].countryRegionId);
            //@ts-ignore
            setCountry({ value: country[0].countryRegionId, label: country[0].CountryName });

            setCartState(cartState);
        }
    };
    const getCurrentLanguage = async () => {
        const currentLanguage =
            props.context.request.locale.length > 2 ? props.context.request.locale.split('-')[0] : props.context.request.locale;
        let language;
        // @ts-ignore
        if (props.data.languages.result) {
            // @ts-ignore
            language = props.data.languages.result.filter(language => {
                const langId = language.LanguageId!.split('-');

                return langId[0] === currentLanguage;
            });
        }
        if (language && language[0]) {
            setSelectedLanguage(language[0].LanguageId || 'en');
            //@ts-ignore
            setLanguage({ value: language[0].LanguageId, label: language[0].languageName });
        }
        return currentLanguage;
    };
    React.useEffect(() => {
        void getCurrentCountry();
        void getCurrentLanguage();
        // @ts-ignore
    }, [props.data.languages.status, props.data.countries.status]);
    const {
        isModalOpen,
        modalContainer,
        // modalHeaderContainer,
        // modalBodyContainer,
        heading,
        modalFooterContainer,
        subheading,
        link,
        countryList,
        stayOnCurrentSiteButton,
        resources
    } = props;

    // @ts-ignore
    const countriesList = props?.data?.countries?.result;
    // @ts-ignore
    const languagesList = props?.data?.languages?.result;

    const countries: CountryOption[] = [];
    const languages: LanguageOption[] = [];

    countriesList?.map((country: any) => {
        const option: CountryOption = { label: country.CountryName || '', value: country.countryRegionId || '', country: country };
        countries.push(option);
    });

    languagesList?.map((language: any) => {
        const option: LanguageOption = { label: language.languageName || '', value: language.LanguageId || '', language: language };
        languages.push(option);
    });

    let sortedRegions: any;
    if (countries) {
        sortedRegions = countries.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
    }
    let sortedLanguages: any;
    if (languages) {
        sortedLanguages = languages.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
    }

    const onCountryChange = (option: any) => {
        const country = countries.filter(country => {
            return country.value === option;
        });

        setCountry(country[0]);
    };

    const onLanguageChange = (option: any) => {
        const language = languages.filter(lang => {
            return lang.value === option;
        });

        setLanguage(language[0]);
    };

    const setLocalization = () => {
        const countryCodes = countryCodeList.filter((countryCodeItem: any) => {
            return countryCodeItem.threeLetterCode === country?.value;
        });
        // const urlForCookie = props.context.request.url.requestUrl.origin;
        const urlForCookie = window.location.origin;
        let cookieUrl: string;
        if (
            selectedCountry.toLocaleLowerCase() === props.config.baseURLCountry.toLocaleLowerCase() &&
            selectedLanguage === props.config.baseURLLanguage.toLocaleLowerCase()
        ) {
            cookieUrl = urlForCookie;
        } else {
            cookieUrl = `${urlForCookie}/${country?.value.toLocaleLowerCase() || 'usa'}/${language?.value || 'en'}`;
        }

        props.onContinue(cookieUrl, countryCodes[0].twoLetterCode);
        const locale: ILocale = {
            country: country?.value.toLocaleLowerCase() || '',
            language: language?.value || ''
        };
        if (
            selectedCountry.toLocaleLowerCase() === props.config.baseURLCountry.toLocaleLowerCase() &&
            selectedLanguage === props.config.baseURLLanguage.toLocaleLowerCase()
        ) {
            window.location.assign(urlForCookie);
        } else {
            setLocale(locale, props.context.actionContext.requestContext);
        }
    };
    return isModalOpen && countryList ? (
        <Module {...modalContainer}>
            <div style={{ paddingTop: '20px', paddingLeft: '24px' }}>
                {heading}
                {subheading}
            </div>
            <div className='PadBox'>
                <p>
                    {resources.countryLanguageDescriptionOne} {resources.countryLanguageDescriptionTwo}
                </p>
                <div className='OptionsContainer'>
                    <div className='InlineContainer'>
                        <label style={{ width: '100%' }}>
                            <div className='SelectLabel'>{resources.countrySelectLabel}</div>
                            <select
                                placeholder={resources.countrySelectPlaceholder}
                                onChange={(e: any) => onCountryChange(e.target.value)}
                                style={{ width: '100%', height: '38px' }}
                                disabled={true}
                            >
                                <option value='' disabled></option>
                                {sortedRegions
                                    ? sortedRegions.map((region: CountryOption, index: any) => {
                                          return (
                                              <option
                                                  value={region.value}
                                                  key={index}
                                                  selected={country && country.value === region.value ? true : false}
                                              >
                                                  {region.label}
                                              </option>
                                          );
                                      })
                                    : countries.map((region: CountryOption, index: any) => {
                                          return (
                                              <option
                                                  value={region.value}
                                                  key={index}
                                                  selected={country && country.value === region.value ? true : false}
                                              >
                                                  {region.label}
                                              </option>
                                          );
                                      })}
                            </select>
                        </label>
                    </div>
                    <div className='InlineContainer'>
                        <label style={{ width: '100%' }}>
                            <div className='SelectLabel'>{resources.languageSelectLabel}</div>
                            <select
                                placeholder={resources.languageSelectPlaceholder}
                                onChange={(e: any) => onLanguageChange(e.target.value)}
                                style={{ width: '100%', height: '38px' }}
                            >
                                <option value='' disabled></option>
                                {sortedLanguages
                                    ? sortedLanguages.map((lang: LanguageOption, index: any) => {
                                          return (
                                              <option
                                                  value={lang.value}
                                                  key={index}
                                                  selected={language && language.value === lang.value ? true : false}
                                              >
                                                  {lang.label}
                                              </option>
                                          );
                                      })
                                    : languages.map((lang: LanguageOption, index: any) => {
                                          return (
                                              <option
                                                  value={lang.value}
                                                  key={index}
                                                  selected={language && language.value === lang.value ? true : false}
                                              >
                                                  {lang.label}
                                              </option>
                                          );
                                      })}
                            </select>
                        </label>
                    </div>
                </div>
                <p>
                    {resources.countryLanguageDescriptionThree}{' '}
                    <a href={props.config.globalServiceCenterLink?.linkUrl.destinationUrl || ''}>
                        {props.config.globalServiceCenterLink?.linkText}
                    </a>{' '}
                    {resources.countryLanguageDescriptionFour}{' '}
                    <a href={props.config.distributionServiceLink?.linkUrl.destinationUrl || ''}>
                        {props.config.distributionServiceLink?.linkText}
                    </a>
                    {resources.countryLanguageDescriptionFive ? resources.countryLanguageDescriptionFive : ''}
                </p>
            </div>
            <Primary onClick={() => setLocalization()} fullWidth={true}>
                {resources.countryLanguageContinueButtonText}
            </Primary>
            {/* <Node {...modalHeaderContainer}>
                {heading}
                {subheading}
            </Node>
            <Node {...modalBodyContainer}>
                {countryList.map(country => (
                    <>{country}</>
                ))}
            </Node> */}
            <Node {...modalFooterContainer}>
                {stayOnCurrentSiteButton}
                {link}
            </Node>
        </Module>
    ) : null;
};

export default countryPickerView;
